export const AI_ACCESS_PROMPT_EVENT = 'synkro:ai-access-prompt';

export type AIAccessPromptReason = 'plan' | 'sign-in';

export function requestAIAccessPrompt(reason: AIAccessPromptReason) {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent<AIAccessPromptReason>(AI_ACCESS_PROMPT_EVENT, { detail: reason }));
  }
}
